(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cv2-karte"] && !Shopify.designMode) return;
  try {
    (function(){
  if (window.cv2Schnellkauf) return;
  window.cv2Schnellkauf = true;
  var d = document, html = d.documentElement, blatt = null, ausloeser = null, hinweisZeit = 0;
  var FEHLER = 'Das hat nicht geklappt. Bitte versuche es noch einmal.';
  function el(tag, cls, text){ var e = d.createElement(tag); if (cls) e.className = cls; if (text != null) e.textContent = text; return e; }
  function korbUrl(){ return (window.routes && window.routes.cart_url) || '/cart'; }

  function hinweis(text){
    var h = d.querySelector('.c2-hinweis');
    if (!h) { h = el('div', 'c2-hinweis'); h.setAttribute('role', 'status'); h.hidden = true; d.body.appendChild(h); }
    h.textContent = text; h.hidden = false;
    clearTimeout(hinweisZeit); hinweisZeit = setTimeout(function(){ h.hidden = true; }, 4000);
  }

  /* Ein Hinweis-Element für alle Kacheln: "Im Warenkorb" + Link, nach 4 s weg */
  var toastZeit = 0;
  function toast(){
    var t = d.querySelector('.c2-toast');
    if (!t) {
      t = el('div', 'c2-toast'); t.setAttribute('role', 'status'); t.hidden = true;
      t.appendChild(el('span', 'tt', 'Im Warenkorb'));
      var a = el('a', 'tl', 'Warenkorb ansehen'); a.href = korbUrl(); t.appendChild(a);
      d.body.appendChild(t);
    }
    t.hidden = false;
    requestAnimationFrame(function(){ t.classList.add('auf'); });
    clearTimeout(toastZeit);
    toastZeit = setTimeout(function(){ t.classList.remove('auf'); setTimeout(function(){ if (!t.classList.contains('auf')) t.hidden = true; }, 250); }, 4000);
  }
  /* "+" wird für 1,5 s zum Haken, der Hover-Knopf am Rechner zeigt kurz "Im Warenkorb" */
  function haken(k){
    if (!k || !k.classList) return;
    var ziel = k.classList.contains('plus') ? k.querySelector('span') || k : k;
    if (!k.classList.contains('plus') && !k.classList.contains('atc')) return;
    if (k.cv2Alt == null) k.cv2Alt = ziel.textContent;
    ziel.textContent = k.classList.contains('plus') ? '\u2713' : '\u2713 Im Warenkorb';
    k.classList.add('ok');
    clearTimeout(k.cv2Haken);
    k.cv2Haken = setTimeout(function(){ ziel.textContent = k.cv2Alt; k.cv2Alt = null; k.classList.remove('ok'); }, 1500);
  }
  /* Zahl im Kopf aus /cart.js */
  function zahlNeu(){
    fetch(korbUrl() + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function(r){ return r.json(); })
      .then(function(c){
        if (!c) return;
        [].forEach.call(d.querySelectorAll('#cart-icon-bubble .c2-zahl'), function(z){ z.textContent = c.item_count; });
        [].forEach.call(d.querySelectorAll('#cart-icon-bubble .visually-hidden'), function(z){ z.textContent = 'Warenkorb, ' + c.item_count + ' Artikel'; });
      }).catch(function(){});
  }

  /* In den Warenkorb wie Dawn: sections mitschicken, danach Schublade über renderContents */
  /* Mit Geschenkleiter: auf der Kachel bestätigen statt wegzuspringen */
  function bestaetige(quelle){
    var karte = quelle && quelle.closest ? quelle.closest('.k') : null;
    if (!karte) { hinweis('Im Warenkorb'); return; }
    var kb = karte.querySelector('.kb') || karte;
    var ok = kb.querySelector('.k-ok');
    if (!ok) { ok = el('span', 'k-ok'); ok.setAttribute('role', 'status'); kb.appendChild(ok); }
    ok.textContent = '\u2713 Im Warenkorb'; ok.hidden = false;
    clearTimeout(ok.cv2Zeit); ok.cv2Zeit = setTimeout(function(){ ok.hidden = true; }, 2600);
  }

  function legeIn(id, knopf, fertig, fehler, form){
    if (knopf) { if (knopf.getAttribute('aria-busy') === 'true') return; knopf.setAttribute('aria-busy', 'true'); }
    var leiter = d.querySelector('[data-cv2-leiter]');
    var drawer = leiter ? null : d.querySelector('cart-drawer');
    var bubble = d.getElementById('cart-icon-bubble');
    var zahl = bubble ? bubble.querySelector('.c2-zahl') : null;
    var fd = new FormData();
    fd.append('id', id); fd.append('quantity', 1);
    if (form) [].forEach.call(form.querySelectorAll('input[name^="properties["]'), function(x){ fd.append(x.name, x.value); });
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      var teile = [];
      drawer.getSectionsToRender().forEach(function(x){ if (!(zahl && x.id === 'cart-icon-bubble')) teile.push(x.id); });
      fd.append('sections', teile.join(','));
      fd.append('sections_url', window.location.pathname);
      if (typeof drawer.setActiveElement === 'function') drawer.setActiveElement(ausloeser || knopf);
    }
    fetch(((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js', { method: 'POST', headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' }, body: fd })
      .then(function(r){ return r.json(); })
      .then(function(res){
        if (knopf) knopf.removeAttribute('aria-busy');
        if (res && res.status) { fehler(res.description || res.message || FEHLER); return; }
        fertig();
        /* Schnellkauf bleibt auf der Seite: Haken am Knopf, Zahl im Kopf, kurzer Hinweis unten. Kein Sprung zum Warenkorb. */
        haken(ausloeser || knopf);
        if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
          try { window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: id, cartData: res }); } catch (err) {}
        }
        if (zahl && res.sections) res.sections['cart-icon-bubble'] = '\x3cdiv class="shopify-section">' + bubble.innerHTML + '\x3c/div>';
        if (drawer && typeof drawer.renderContents === 'function' && res.sections) {
          try { drawer.classList.remove('is-empty'); drawer.renderContents(res, true); } catch (err) {}
        }
        zahlNeu();
        if (leiter) {
          bestaetige(ausloeser || knopf);
          try { d.dispatchEvent(new CustomEvent('cv2:korb', { detail: res })); } catch (err) {}
          return;
        }
        toast();
      })
      .catch(function(){
        if (knopf) knopf.removeAttribute('aria-busy');
        fehler(FEHLER);
      });
  }

  function schliesse(fokus){
    if (!blatt || blatt.hidden) return;
    blatt.classList.remove('auf');
    html.style.overflow = '';
    setTimeout(function(){ blatt.hidden = true; }, 220);
    if (fokus && ausloeser && ausloeser.focus) ausloeser.focus();
  }

  function baueBlatt(){
    blatt = el('div', 'c2-blatt'); blatt.hidden = true;
    blatt.setAttribute('role', 'dialog'); blatt.setAttribute('aria-modal', 'true'); blatt.setAttribute('aria-labelledby', 'c2-blatt-titel');
    var schl = el('div', 'schl'); schl.addEventListener('click', function(){ schliesse(true); });
    var inn = el('div', 'in');
    blatt.appendChild(schl); blatt.appendChild(inn);
    d.body.appendChild(blatt);
    d.addEventListener('keydown', function(e){ if (e.key === 'Escape') schliesse(true); });
    return inn;
  }

  function oeffne(karte, knopf){
    var quelle = karte.querySelector('script[data-cv2-varianten]');
    if (!quelle) return false;
    var info; try { info = JSON.parse(quelle.textContent); } catch (err) { return false; }
    ausloeser = knopf;
    var inn = blatt ? blatt.querySelector('.in') : baueBlatt();
    inn.textContent = '';
    var ko = el('div', 'ko');
    if (info.bild) { var im = el('img'); im.src = info.bild; im.alt = ''; im.width = 56; im.height = 56; ko.appendChild(im); }
    var ti = el('b', '', info.titel); ti.id = 'c2-blatt-titel'; ko.appendChild(ti);
    var x = el('button', 'zu', 'Schließen'); x.type = 'button'; x.addEventListener('click', function(){ schliesse(true); }); ko.appendChild(x);
    inn.appendChild(ko);
    var fe = el('p', 'fe'); fe.setAttribute('role', 'alert'); fe.hidden = true;
    info.v.forEach(function(v){
      var z = el('button', 'zr'); z.type = 'button';
      if (v.b) { var vb = el('img'); vb.src = v.b; vb.alt = ''; vb.width = 44; vb.height = 44; vb.loading = 'lazy'; z.appendChild(vb); }
      var n = el('span', 'n', v.t);
      if (v.j) n.appendChild(el('small', '', v.j));
      if (!v.a) n.appendChild(el('small', '', 'Ausverkauft'));
      z.appendChild(n);
      var pr = el('span', 'pr', v.p);
      if (v.s) pr.appendChild(el('s', '', v.s));
      z.appendChild(pr);
      var pl = el('span', 'pl', '+'); pl.setAttribute('aria-hidden', 'true'); z.appendChild(pl);
      z.setAttribute('aria-label', v.t + ', ' + v.p + (v.j ? ', ' + v.j : '') + (v.a ? ', in den Warenkorb' : ', ausverkauft'));
      if (!v.a) z.disabled = true;
      z.addEventListener('click', function(){
        fe.hidden = true;
        legeIn(v.i, z, function(){ schliesse(false); }, function(t){ fe.textContent = t; fe.hidden = false; });
      });
      inn.appendChild(z);
    });
    inn.appendChild(fe);
    var det = el('a', 'det', 'Alle Details ansehen'); det.href = info.url; inn.appendChild(det);
    blatt.hidden = false;
    html.style.overflow = 'hidden';
    requestAnimationFrame(function(){ requestAnimationFrame(function(){ blatt.classList.add('auf'); }); });
    var erste = inn.querySelector('.zr:not([disabled])') || x;
    setTimeout(function(){ erste.focus(); }, 30);
    return true;
  }

  d.addEventListener('click', function(e){
    var k = e.target.closest ? e.target.closest('[data-cv2-wahl]') : null;
    if (!k) return;
    var karte = k.closest('.k');
    if (karte && oeffne(karte, k)) e.preventDefault();
  });

  d.addEventListener('submit', function(e){
    var f = e.target;
    if (!f.matches || !f.matches('form[data-cv2-schnell]')) return;
    e.preventDefault();
    var knopf = e.submitter || f.querySelector('button');
    ausloeser = knopf;
    legeIn(f.querySelector('input[name="id"]').value, knopf, function(){}, hinweis, f);
  });
})();
  } catch(e) { console.error(e); }
})();

})();
